import { render, staticRenderFns } from "./Fragment.vue?vue&type=template&id=04cd58a1&"
import script from "./Fragment.vue?vue&type=script&lang=js&"
export * from "./Fragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports